import React  from 'react';
import a_Product_Data from './a_Product_Data';
import a_Category_Data from './a_Category_Data';
import Slider_Small from './Slider_Small';

const Product_List = ({ addToCart,addToFavorites }) => {
    const products = a_Product_Data;
    const categories = a_Category_Data;

    return (
        <> 
            {products.map((product, index) => {
                const productId = `${product[0]}_${index}`; // Create a unique identifier for each product
                const categoryId = product[2].toString();
                const category = categories.find(category => category && category[1] === categoryId);
                const categoryName = category ? category[0] : 'Unknown Category';



                return (
                    <div className='product-card col-md-6 col-lg-4 col-xl-3 pt-1 pb-4 bg-white' key={productId}>
                        <div>
                            <span>{product[4]}</span>
                            <a  onClick={() => addToFavorites(index)} className='add-to-Favorites-button'>Add to Favorites</a>
                        </div>
                        <div className='image'>
                            <Slider_Small product_index_id={index} />
                        </div>
                        <div>
                            <div className='brand'>
                                <a href={`/brand/${product[3]}/`}>{product[3]}</a>
                            </div>
                            <h5 className='title'>
                                <a href={`/product/${productId.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '')}`}>{product[0]}</a>
                            </h5>
                            <div className='category'>
                                <a href={`/category/${categoryId}/`}>{categoryName}</a>
                            </div>
                            <div className='price'>${product[1]}</div>
                        </div>
                        <div className='action'>
                        <a  onClick={() => addToCart(index)}>Add to cart</a>
                        </div>
                    </div>
                );
            })}
        </>
    );
}

export default Product_List;